<div class="mockServerSettingsPage">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="mock-server-settings-wrapper">
          <h1 class="wrapperTitle">
            Mock Server Settings
          </h1>

          <div class="settings-content">
            <div class="item mockServerStatus" [class.enabled]="mockServerEnabled">
              <h3 class="itemTitle">Mock Server Status:&nbsp;</h3>
              <p class="status-text" [ngClass]="{'enabled': mockServerEnabled, 'disabled': !mockServerEnabled}">
                {{ mockServerEnabled ? 'Enabled' : 'Disabled' }}
              </p>
            </div>
            <div class="item settingsDataWrapper">
              <nz-table #basicTable [nzData]="listOfMockServerEndPoints" [nzBordered]="true" [nzSize]="'middle'"
                class="mockServerSettingsTable">
                <thead>
                  <tr>
                    <th>Endpoints</th>
                    <th>Case</th>
                    <th>Status</th>
                    <th>Last Updated Mock Data</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let data of basicTable.data">
                    <td>{{ data.req_method }} &nbsp;{{ data.req_url }}</td>
                    <td>{{data.res_case}}</td>
                    <td>{{ data.res_status }}</td>
                    <td>{{data.req_lastUpdated}}</td>
                    <td>
                      <ion-button color="danger" matRipple (click)="confirmDeletion(data)">
                        Delete &nbsp;<mat-icon>delete_forever</mat-icon>
                      </ion-button>
                    </td>
                  </tr>

                </tbody>
              </nz-table>

              <!-- <nz-table #nzTable [nzData]="listOfMockServerEndPoints" [nzBordered]="true" [nzSize]="'middle'"
                class="mockServerSettingsTable">
                <thead>
                  <tr>
                    <th nzCustomFilter>
                      Endpoints
                      <nz-filter-trigger [(nzVisible)]="visible" [nzActive]="searchValue.length > 0"
                        [nzDropdownMenu]="menu">
                        <nz-icon nzType="search" />
                        Search
                      </nz-filter-trigger>
                    </th>
                    <th>Case</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of basicTable.data">
                    <td>{{ data.req_method }} &nbsp;{{ data.req_url }}</td>
                    <td>{{data.res_case}}</td>
                    <td>{{ data.res_status }}</td>
                    <td>
                      <ion-button color="danger" matRipple>
                        Delete &nbsp;<mat-icon>delete_forever</mat-icon>
                      </ion-button>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <div class="ant-table-filter-dropdown">
                  <div class="search-box">
                    <input type="text" nz-input placeholder="Search name" [(ngModel)]="searchValue" />
                    <button nz-button nzSize="small" nzType="primary" (click)="search()"
                      class="search-button">Search</button>
                    <button nz-button nzSize="small" (click)="reset()">Reset</button>
                  </div>
                </div>
              </nz-dropdown-menu> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>